import { apiRequest } from "../utils/async/apiRequest";

export const authCompanyLogin = async (params) => {
  try {
    const res = await apiRequest("post", "company-login", { body: params });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const authAdminLogin = async (params) => {
  try {
    const res = await apiRequest("post", "admin-login", { body: params });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const getProfile = async (params) => {
  try {
    const res = await apiRequest("get", "profile");
    return res?.data;
  } catch (error) {
    return error;
  }
};
